import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectorRef,
  PLATFORM_ID,
  InjectionToken,
  input,
  inject,
  output
} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { LandingPage } from 'src/app/landing-page/models';
import { Location } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  standalone: false,
})
export class TopbarComponent implements OnInit {
  private cd = inject(ChangeDetectorRef);
  private platformId = inject<InjectionToken<Object>>(PLATFORM_ID);
  private router = inject(Router);

  readonly loading = input<boolean>(false);
  readonly menuActive = input<boolean>(false);
  readonly logoClass = input<string>('');
  readonly menuItems = input<LandingPage[]>([]);

  readonly toggleOverlay = output<void>();
  readonly closeOverlay = output<void>();
  readonly openOverlay = output<void>();

  fixed = false;

  funnel = input<boolean>(false);
  location = inject(Location);

  constructor() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe(s => {
      if (s instanceof NavigationStart && this.menuActive()) {
        // TODO: The 'emit' function requires a mandatory void argument
        this.closeOverlay.emit();
      }
    });
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      fromEvent(window, 'scroll')
        .pipe(debounceTime(20))
        .subscribe(a => {
          // show scrollbar after windowinnerheight (window.innerHeight)
          if (window.scrollY > 96) {
            this.fixed = true;
          } else {
            this.fixed = false;
          }
          this.cd.detectChanges();
        });
    }
  }

  goBack(): void {
    const navigationId = (this.location.getState() as any)?.navigationId || 0;

    if (navigationId > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/']);
    }
  }
}
